// @givmo/board — the record history's line for a person recorded as present (CBG-FIX69; backend
// `board_records.md` § Who was recorded as present).
//
// A `participant_added` event's stored note names the account by its id ("Recorded ac000002-… as a
// participant."), and the note never changes. The history read serves the account it names and that
// account's name (`participant_user_id`, `participant_display_name`), so the line names the person
// and the note is never printed for this event.
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// "Someone was recorded as present" is the shipped line, kept word for word for a person whose name
// isn't shown. The other two (CBG-FIX69) are approved as drafted on the cut's copy page
// (`scratchpad/2026-10-15-export-copy-round/copy-review.html`, 2026-10-15 07:49 PDT). No pronoun
// for a named person.

export const historyWords = {
  // Approved (CBG-FIX69's copy page, 2026-10-15): the person the history names.
  recordedAsPresent: (name: string) => `${name} was recorded as present`,
  // Shipped: the person's name isn't shown.
  someoneRecordedAsPresent: 'Someone was recorded as present',
  // Approved (CBG-FIX69's copy page, 2026-10-15): RC10's custody catch-up, which no officer
  // recorded. Board added the account that held the seat of someone recorded in the closed session
  // (CBG-FIX43).
  addedFromTheSession: 'Added by Board from the people recorded in this session',
} as const;
